import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const TableOfContents = () => {
  return (
    <section className={"content"}>
      <Grid container={true} spacing={3}>
        <Grid item={true} xs={12}>
          <Typography
            variant="h4"
            gutterBottom={true}
            style={{ opacity: 0.4, fontWeight: 300 }}
          >
            Table of Contents
          </Typography>
        </Grid>
        <Grid item={true} xs={9}>
          <ul className={"table-of-contents"}></ul>
        </Grid>
      </Grid>
    </section>
  );
};

export default TableOfContents;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/TableOfContents.jsx